// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"502":"d2c86127","596":"178e4091"}[chunkId] + "." + {"502":"cde85a7db044c928","596":"47ec2b6baea43e2a"}[chunkId] + ".js";
};